const numberFormat = new Intl.NumberFormat('es-CU', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})

/**
 * Formatea un monto + el NOMBRE de la moneda del backend (p. ej. "1 500,00 CUP").
 * No usa `Intl` currency style porque `currency.name` no es necesariamente un
 * código ISO. Si no hay nombre de moneda, devuelve solo el número.
 */
export function formatServicePrice(amount: number, currencyName?: string | null): string {
  const formatted = numberFormat.format(amount)
  return currencyName ? `${formatted} ${currencyName}` : formatted
}
